"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationAreaCode = exports.CellId = void 0;
const effect_1 = require("effect");
const binary_1 = require("../../binary");
const NAMESPACE = 'Network.Cellular.Wcdma';
exports.CellId = effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 268_435_455)).annotations({
    identifier: `${NAMESPACE}.CellId`,
});
exports.LocationAreaCode = binary_1.Uint16.annotations({
    identifier: `${NAMESPACE}.LocationAreaCode`,
});
//# sourceMappingURL=wcdma.js.map